//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import importservice from "../../services/import";
import { DateTime, persist, array, pointName, number } from "../../utils";
import ruleservice from "../../services/rules";
import moment from "moment-timezone";
import pointsservice from "../../services/points";
import { types as sitetreetypes } from "../../services/SiteTree/redux";
import { types as searchbartypes } from "../../components/SearchBar/redux";

const initialState = {
	data: [],
	time: {
		startDate: DateTime.startOf("day"),
		endDate: DateTime.endOf("day"),
		key: "selection"
	},
	isBusy: false,
	query: "",
	errors: [],
};

const persistConf = {
	whitelist: ["time"]
};

/////////
//types
export const types = {
	GET_DATA: "screens/summary/GET_DATA",
	ON_GET_DATA: "screens/summary/ON_GET_DATA",
	ON_GET_FAIL_DATA: "screens/summary/ON_GET_FAIL_DATA",
	CHANGE_TIME: "screens/summary/CHANGE_TIME",
	ERROR: "screens/summary/ERROR",
};

///////////
//reducers
const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.GET_DATA:
				return { ...state, isBusy: true };
			case types.ON_GET_DATA:
				return { ...state, data: action.payload.data, isBusy: false };
			case types.ON_GET_FAIL_DATA:
				return { ...state, isBusy: false, failData: action.payload.data };
			case types.CHANGE_TIME:
				return {
					...state,
					time: action.payload.time
				};
			default:
				return state;
		}
	}
};
export const reducer = persist("summary", reducers.reducer, persistConf);

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.getData(), 
		]);
	},

	*getData() {
		yield takeEvery(
			[types.GET_DATA, types.CHANGE_TIME],
			function*({ payload }) {
				let { time } = yield select(x => ({
					time: x.summary.time,
				}));
				const from = moment(time.startDate);
				const to = moment(time.endDate);

				const result = yield call(ruleservice.GetRuleSummaryStats, from, to);

				if (result instanceof Error) {
					yield put(actions.error(result));
				} else {
					const utcOffset = moment().utcOffset();

					for (let index = 0; index < result.length; index++) {
						const item = result[index];
						item.lastOutputDate =
							item.lastOutputDate && moment(item.lastOutputDate).subtract(utcOffset, "minutes");
					}

					yield put(actions.onGetData(result));
				}
			}
		);
	},
};

////////
//actions
export const actions = {
	getData() {
		return {
			type: types.GET_DATA,
			payload: {}
		};
	},
	onGetData(data) {
		return {
			type: types.ON_GET_DATA,
			payload: { data }
		};
	},
	onGetFailData(data) {
		return {
			type: types.ON_GET_FAIL_DATA,
			payload: { data }
		}
	},
	changeTime(time) {
		return {
			type: types.CHANGE_TIME,
			payload: { time: time.selection }
		};
	},

	error(error) {
		return {
			type: types.ERROR,
			payload: error
		};
	},
};



// WEBPACK FOOTER //
// ./src/ui/Summary/redux.js